import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm, SubmitHandler } from "react-hook-form";
import {
  ButtonSend,
  Container,
  InputBase,
  LeftWrapper,
  MainContent,
  RightWrapper,
  Text
} from "./styles";

// import imageBackgroundDecoration from "../../assets/background-templates.svg";
import IconSvg from "../../../editor/components/IconSvg";
import LogoUx from "../../assets/logo-new.svg";
import api from "../../../../services/api";
import { toast, ToastContainer } from "react-toastify";
import { LoadingFlex } from "../../../login/pages/Login/styles";
import PuffLoader from "react-spinners/PuffLoader";
import logoUX3 from "../../../login/assets/uxlogotipo.svg";
import { useToolbarEditor } from "../../../editor/hooks/toolbarEditor";

interface SubmitProps {
  email: string;
}

const ForgotPasswordScreen: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { setBlockCommandKeyboard, forceBlockKey, setForceBlockKey } =
    useToolbarEditor();

  useEffect(() => {
    setForceBlockKey(true);
  }, []);

  const schema = yup.object({
    email: yup.string().email("Email invalido").required()
  });

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<SubmitProps>({
    resolver: yupResolver(schema)
  });

  const onSubmit: SubmitHandler<SubmitProps> = async data => {
    try {
      setIsLoading(true);
      const responseForgotPassword = await api.post("password/forgot", data);
      toast.success("Email enviado com sucesso!");
      setIsLoading(false);
    } catch (err) {
      console.log(err, "error when post forgot password");
      toast.error("Algo deu errado. Tente novamente mais tarde.");
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <ToastContainer position="top-left" />
      <LeftWrapper>
        <MainContent onSubmit={handleSubmit(onSubmit)}>
          {/* <div className="container-logo" /> */}

          <div className="hero-login-div">
            <img className="hero-login-img" src={logoUX3} />
          </div>
          <Text>Esqueci minha senha</Text>
          <span className="text-forgotpassword">
            Esqueceu sua senha? Insira seu email e enviaremos um link para
            recuperar sua conta
          </span>
          <InputBase type="text" placeholder="Email" {...register("email")} />
          {errors.email?.message && (
            <div className="force-margin">
              <p className="error-validation">
                {errors.email?.message === "email is a required field"
                  ? "Campo obrigatório"
                  : errors.email.message}
              </p>
            </div>
          )}
          <ButtonSend>
            {isLoading ? (
              <LoadingFlex>
                <PuffLoader color="#ffff" size="28" />
              </LoadingFlex>
            ) : (
              "Enviar"
            )}
          </ButtonSend>
        </MainContent>
      </LeftWrapper>
      <RightWrapper />
    </Container>
  );
};

export default ForgotPasswordScreen;
